import { render } from "./CarroDetalhes.vue?vue&type=template&id=bee40b5e&scoped=true"
import script from "./CarroDetalhes.vue?vue&type=script&lang=js"
export * from "./CarroDetalhes.vue?vue&type=script&lang=js"

import "./CarroDetalhes.vue?vue&type=style&index=0&id=bee40b5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee40b5e"]])

export default __exports__